import { render } from "./system.web.vue?vue&type=template&id=480a7358&ts=true"
import script from "./system.web.vue?vue&type=script&scoped=true&lang=ts"
export * from "./system.web.vue?vue&type=script&scoped=true&lang=ts"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__